import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

export interface ICheckboxChangeWithEvent {
  checked: boolean;
  event: MouseEvent;
}

@Component({
  selector: 'ngx-doc-form-checkbox',
  templateUrl: './doc-form-checkbox.component.html',
  styleUrls: ['./doc-form-checkbox.component.scss'],
})
export class DocFormCheckboxComponent implements OnInit {
  @Input() label: string;
  @Input() value: boolean;
  @Input() disabled: boolean = false;
  @Input() withEvent = false;
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueWithEventChange: EventEmitter<ICheckboxChangeWithEvent> = new EventEmitter<ICheckboxChangeWithEvent>()

  mouseEvent: MouseEvent = null;

  constructor() {
    this.valueChange = new EventEmitter<boolean>();
  }

  ngOnInit() {
  }

  mousedown(event: MouseEvent) {
    this.mouseEvent = event;
  }

  updateValue(value: boolean) {
    this.valueChange.emit(value );
  }

  handleEvent(event: Event) {
    this.valueWithEventChange.emit({ checked: (event.target as HTMLInputElement)?.checked, event: this.mouseEvent } as ICheckboxChangeWithEvent);
    this.valueChange.emit((event.target as HTMLInputElement)?.checked);
    this.mouseEvent = null;
  }


}
